/* prettier-ignore-file */
/**
 * Single loader for the Google Maps JS API.
 *
 * The app previously had four independent loaders (MapViewer, RoutePlanner,
 * GoogleAddressInput, and the rental calculator) requesting DIFFERENT `libraries`
 * sets. Only the first request actually loads, so whether `geometry` was available
 * depended on which screen the user happened to open first. Asking for the union
 * every time removes that race.
 *
 * Resolves immediately if the API is already present, and attaches to an in-flight
 * <script> rather than injecting a second one.
 */

const GOOGLE_MAPS_API_KEY = "AIzaSyDnMrIVkx-6V0Brm4pxezeOVcTOELsTmdQ";
const LIBRARIES = "places,geometry";

let loadPromise = null;

export const ensureGoogleMaps = () => {
  if (window.google?.maps) return Promise.resolve(window.google.maps);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(window.google.maps));
      existing.addEventListener("error", () => {
        loadPromise = null; // allow a retry on a later call
        reject(new Error("Google Maps failed to load"));
      });
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=${LIBRARIES}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve(window.google.maps);
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Google Maps failed to load"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};

export default ensureGoogleMaps;
